// Base translations — English
export default {
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.search': 'Search',
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.retry': 'Retry',
  'common.add': 'Add',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.all': 'All',
  'common.yes': 'Yes',
  'common.no': 'No',

  'home.nav_features': 'Features',
  'home.nav_how': 'How it works',
  'home.nav_pricing': 'Pricing',
  'home.nav_faq': 'FAQ',
  'home.create_site': 'Create my site',
  'home.my_space': 'My Zifek space',
  'home.logout': 'Log out',

  'auth.login': 'Login',
  'auth.register': 'Sign up',
  'auth.client_space': 'Client area',
  'auth.client_space_desc': 'My purchases, my files',
  'auth.pro_space': 'Business area',
  'auth.pro_space_desc': 'Manage my store',

  'dash.dashboard': 'Dashboard',
  'dash.products': 'Products',
  'dash.caisse': 'My register',
  'dash.services': 'Services',
  'dash.orders': 'Orders',
  'dash.customers': 'Customers',
  'dash.credit': 'Credit',
  'dash.payments': 'Payments',
  'dash.wallet': 'Wallet',
  'dash.store': 'My store',
  'dash.my_website': 'My website',
  'dash.site_content': 'Site content',
  'dash.media': 'Media',
  'dash.documents': 'Documents',
  'dash.storage': 'Storage',
  'dash.analytics': 'Analytics',
  'dash.appstore': 'AppStore',
  'dash.apps': 'My apps',
  'dash.themestore': 'ThemeStore',
  'dash.settings': 'Settings',
  'dash.account': 'My account',
  'dash.profile': 'My profile',
  'dash.install_app': 'Install app',
  'dash.my_qr': 'My Zifek QR',
  'dash.logout': 'Log out',
  'dash.notifications': 'Notifications',
  'dash.preview_site': 'Preview',
  'dash.view_site': 'View site',

  'sa.dashboard': 'Dashboard',
  'sa.users': 'Users',
  'sa.core': 'Zifek Core',
  'sa.themes': 'Theme Builder',
  'sa.apps': 'App Builder',
  'sa.homepage': 'Homepage',
  'sa.translations': 'Languages & Translations',
  'sa.support': 'Customer support',
  'sa.logs': 'System logs',
  'sa.accountTypes': 'Account types',
  'sa.database': 'Database & API',
  'sa.storage': 'Storage',
  'sa.settings': 'AI settings',

  'support.title': 'Customer Service & Support',
  'support.new_ticket': 'New ticket',
  'support.subject': 'Subject',
  'support.message': 'Message',
  'support.send': 'Send',
  'support.reply': 'Reply',
  'support.status': 'Status',
  'support.open': 'Open',
  'support.in_progress': 'In progress',
  'support.resolved': 'Resolved',
  'support.closed': 'Closed',
  'support.zifek_team': 'Zifek team',
  'support.contact_team': 'Contact the Zifek team',
  'support.my_requests': 'My requests',

  'credit.title': 'Zifek Credit',
  'credit.carnet': 'Ledger',
  'credit.clients': 'Customers',
  'credit.reports': 'Reports',
  'credit.settings': 'Settings',
  'credit.add_credit': 'Add credit',
  'credit.record_payment': 'Record payment',
  'credit.balance': 'Balance',
  'credit.new_customer': 'Customer',
  'credit.import_photo': 'Debt photo',
  'credit.scan': 'Scan',

  'lang.change': 'Change language',

  'credit.subtitle': 'Your digital credit ledger',
  'credit.tab.carnet': 'Ledger',
  'credit.tab.clients': 'Customers',
  'credit.tab.rapports': 'Reports',
  'credit.tab.reglages': 'Settings',
  'credit.photo_debts': 'Debt photo',
  'credit.add_credit_btn': 'Add credit',
  'credit.search_client': 'Search a customer...',
  'cr.qa_payment': 'Record a payment',
  'cr.qa_add_client': 'Add a customer',
  'cr.qa_import_photo': 'Import from photo',
  'cr.qa_invite': 'Invite a customer',
  'cr.qa_statement': 'Generate a statement',
  'cr.qa_carnet': 'Full ledger',

  'caisse.title': 'My register',
  'caisse.subtitle': 'Point of sale',
  'caisse.search': 'Search a product...',
  'caisse.cart': 'Cart',
  'caisse.empty': 'Empty cart',
  'caisse.checkout': 'Checkout',
  'caisse.new_sale': 'New sale',
  'caisse.subtotal': 'Subtotal',
  'caisse.tax': 'VAT',
  'caisse.total': 'Total',
  'caisse.cash': 'Cash',
  'caisse.card': 'Card',
  'caisse.paid': 'Payment accepted',

  'products.title': 'Products',
  'products.subtitle': 'Manage your product catalog',
  'products.new': 'New product',
  'products.categories': 'Categories',
  'products.catalog': 'Catalog',
  'products.stock_mgmt': 'Stock management',
  'products.search': 'Search a product...',
  'reports.title': 'Reports',

  'currency.change': 'Change currency',
  'currency.equiv': 'equals',
  'credit.enable_reminders': 'Enable credit reminders',

  'orders.title': 'Orders',
  'orders.subtitle': 'Track and manage all orders',
  'orders.filter_all': 'All',
  'orders.filter_pending': 'Pending',
  'orders.filter_paid': 'Paid',
  'orders.filter_processing': 'Processing',
  'orders.filter_shipped': 'Shipped',
  'orders.filter_delivered': 'Delivered',
  'orders.empty': 'No orders',
  'orders.empty_hint': 'Orders will appear here when you receive them',
  'orders.items': 'Items',
  'orders.subtotal': 'Subtotal',
  'orders.shipping': 'Shipping',
  'orders.tax': 'Taxes',
  'orders.discount': 'Discount',
  'orders.total': 'Total',
  'orders.status': 'Status',
  'orders.payment': 'Payment',
  'orders.email': 'Email',
  'orders.phone': 'Phone',

  'payments.title': 'Payments',
  'payments.subtitle': 'Transaction and revenue history',
  'payments.received': 'Received',
  'payments.sent': 'Sent',
  'payments.balance': 'Current balance',
  'payments.filter_all': 'All',
  'payments.filter_received': 'Received',
  'payments.filter_sent': 'Sent',
  'payments.empty': 'No transactions',
  'payments.empty_hint': 'Transactions will appear here',
  'payments.col_type': 'Type',
  'payments.col_amount': 'Amount',
  'payments.col_details': 'Details',
  'payments.col_origin': 'Origin',
  'payments.col_date': 'Date',
  'payments.in': 'Received',
  'payments.out': 'Sent',

  'wallet.title': 'Wallet',
  'wallet.subtitle': 'Your balance, top-ups and transaction history.',
  'wallet.available': 'Available balance',
  'wallet.recharge': 'Top up wallet',
  'wallet.via_paypal': 'Top up via PayPal',
  'wallet.via_stripe': 'Top up via Stripe',
  'wallet.history': 'Transaction history',
  'wallet.empty': 'No transactions yet.',
  'wallet.col_type': 'Type',
  'wallet.col_amount': 'Amount',
  'wallet.col_method': 'Method',
  'wallet.col_details': 'Details',
  'wallet.col_date': 'Date',
  'wallet.type_recharge': 'Top-up',
  'wallet.type_refund': 'Refund',
  'wallet.type_debit': 'Debit',
  'wallet.method_wallet': 'Wallet',
  'wallet.method_admin': 'Administrator',

  'settings.title': 'Settings',
  'settings.subtitle': 'Manage your account and preferences',
  'settings.tab_profile': 'Profile',
  'settings.tab_password': 'Password',
  'settings.tab_domain': 'Domain',
  'settings.tab_appearance': 'Appearance',
  'settings.tab_danger': 'Danger zone',

  'crf.tx_add_credit': 'Add credit',
  'crf.tx_record_payment': 'Record a payment',
  'crf.tx_adjustment': 'Adjustment',
  'crf.tx_hint_credit': 'Amount the customer owes you on top',
  'crf.tx_hint_payment': 'Amount the customer repays you',
  'crf.tx_hint_adjustment': 'Correction (negative amount to reduce the debt)',
  'crf.current_balance': 'Current balance',
  'crf.amount': 'Amount',
  'crf.description': 'Description',
  'crf.description_credit_ph': 'E.g. bag of rice, oil…',
  'crf.description_payment_ph': 'E.g. partial payment',
  'crf.payment_method': 'Payment method',
  'crf.new_balance': 'New balance',
  'crf.confirm': 'Confirm',
  'crf.saving': 'Saving...',
  'crf.invalid_amount': 'Enter a valid amount.',
  'crf.save_error': 'Error while saving',
  'crf.edit_customer': 'Edit customer',
  'crf.new_customer': 'New customer',
  'crf.customer_name': 'Customer name',
  'crf.customer_name_ph': 'E.g. Mohammed Alami',
  'crf.customer_hint': 'No Zifek account required. The customer can be invited later to track their balance.',
  'crf.phone_optional': 'Phone (optional)',
  'crf.credit_limit_optional': 'Credit limit (optional)',
  'crf.usual_payment_date': 'Usual payment date',
  'crf.not_defined': 'Not set',
  'crf.day_of_month': 'On the {day} of the month',
  'crf.notes_optional': 'Notes (optional)',
  'crf.notes_ph': 'E.g. neighbour, pays at month end…',
  'crf.name_required': 'Customer name is required.',
  'crf.create_customer': 'Create customer',
  'crf.client_access': 'Customer access',
  'crf.client_access_desc': 'Here are the customer credentials. Share them so they can sign in to their client area and track their balance and history.',
  'crf.username': 'Username',
  'crf.default_password': 'Default password',
  'crf.client_space': 'Client area',
  'crf.share': 'Share',
  'crf.regen_password': 'Regenerate a password',
  'crf.creds_hint': 'The customer can also change this password from their area.',
  'crf.import_title': 'Import debts from photo',
  'crf.import_sub_upload': 'Photograph the ledger page',
  'crf.import_sub_confirm': 'Confirmation required',
  'crf.import_sub_review': 'Review then confirm',
  'crf.import_desc': 'Take one or more photos of the ledger page (names + amounts). The AI reads the debts and shows them for validation. Nothing is saved before you confirm.',
  'crf.take_photos': 'Take / choose photos',
  'crf.photos_hint': 'Up to 8 photos · JPG, PNG',
  'crf.import_history': 'Import history',
  'crf.import_cancelled': 'Cancelled',
  'crf.cancel_btn': 'Cancel',
  'crf.revert_hint': 'Cancelling an import deletes the debts created (and the customers created by this import).',
  'crf.add_line': 'Add a line',
  'crf.detected_total': '{count} debt(s) detected · total {total}',
  'crf.debt_detail_ph': 'Detail (e.g. 2 bags of flour, bread…)',
  'crf.existing_customer_tag': 'Existing customer — the debt will be added to their account',
  'crf.no_debt': 'No debt. Add a line manually.',
  'crf.ai_read_none': 'The AI read no debt on these photos. Try a sharper, well-lit photo.',
  'crf.ai_failed': 'AI analysis failed',
  'crf.add_at_least_one': 'Add at least one debt with a name and an amount.',
  'crf.confirm_existing_title': 'Customer(s) already existing',
  'crf.confirm_existing_desc': 'These names already exist in your ledger. Do you confirm adding these debts to their existing accounts?',
  'crf.new_clients_count': '{count} new customer(s) will also be created.',
  'crf.creating_progress': 'Creating customers and debts... {done}/{total}',
  'crf.analyse_ai': 'Analyse with AI',
  'crf.reading_ai': 'AI reading...',
  'crf.back': 'Back',
  'crf.validate_create': 'Validate and create',
  'crf.confirm_add_existing': 'Confirm and add to existing accounts',
  'crf.import_failed': 'Import failed',
  'crf.revert_failed': 'Cancellation failed',
  'crf.revert_question': 'Cancel this import?',
  'crf.revert_desc': '{count} debt(s) deleted.',
  'crf.currency': 'Currency',
  'crf.currency_desc': 'Used across the whole credit ledger.',
  'crf.default_due_day': 'Default due day',
  'crf.no_due_day': 'Not set',
  'crf.reminders': 'Reminders',
  'crf.reminders_desc': 'Reminders are sent to your customer through their Zifek app (PWA) if they installed it. If they did not, no automatic reminder is sent.',
  'crf.reminder_new_credit': 'New credit',
  'crf.reminder_payment': 'Payment confirmation',
  'crf.reminder_balance': 'Current balance',
  'crf.reminder_due_date': 'Upcoming due date',
  'crf.reminder_monthly': 'Monthly statement',
  'crf.default_channel': 'Default channel',
  'crf.channel_inapp': 'Client app (PWA)',
  'crf.merchant_qr': 'Merchant invite QR',
  'crf.merchant_qr_desc': 'Show this code at checkout. Your Zifek-connected customers scan it to link their account to your ledger.',
  'crf.show_qr': 'Show QR',
  'crf.last_reminders': 'Latest reminders',
  'crf.save_settings': 'Save settings',
  'crf.saved': 'Saved!',
  'crf.qr_client': 'Customer QR',
  'crf.merchant_invite': 'Merchant invite',
  'crf.link_customer': 'Customer linking link',
  'crf.to_pay': 'to pay',
  'crf.up_to_date': 'up to date',
  'crf.limit_badge': 'Limit',
  'crf.no_phone': 'No phone',
  'crf.ledger_empty_title': 'Your ledger is empty',
  'crf.ledger_empty_desc': 'Add a customer then record a credit in seconds — like a paper ledger, but without the paper.',
  'crf.add_customer': 'Add a customer',
  'crf.no_client_found': 'No customer found',
  'crf.export_csv': 'Export CSV',
  'crf.no_customer': 'No customer registered',
  'crf.col_client': 'Customer',
  'crf.col_balance': 'Balance',
  'crf.col_limit': 'Limit / available',
  'crf.col_due': 'Due',
  'crf.col_actions': 'Actions',
  'crf.no_limit': 'No limit',
  'crf.available_short': 'avail.',
  'crf.linked_account': 'Linked account',
  'crf.last_activity': 'last',
  'crf.tooltip_add_credit': 'Add credit',
  'crf.tooltip_payment': 'Payment',
  'crf.tooltip_invite': 'Invite to Zifek',
  'crf.tooltip_credentials': 'View credentials',
  'crf.tooltip_edit': 'Edit',
  'crf.tooltip_delete': 'Delete',
  'crf.stat_outstanding': 'Total outstanding credit',
  'crf.stat_with_credit': 'Customers with credit',
  'crf.stat_credits_month': 'Credits this month',
  'crf.stat_payments_month': 'Payments received this month',
  'crf.stat_attention': 'Customers to watch',
  'crf.rep_export_balances': 'Balances CSV',
  'crf.rep_export_history': 'History CSV',
  'crf.rep_from': 'From',
  'crf.rep_to': 'To',
  'crf.rep_reset': 'Reset',
  'crf.rep_credits_period': 'Credits (period)',
  'crf.rep_payments_period': 'Payments (period)',
  'crf.rep_adjust_period': 'Adjustments (period)',
  'crf.rep_credits_vs_payments': 'Credits vs payments',
  'crf.rep_last_6': 'Last 6 months',
  'crf.rep_credits': 'Credits',
  'crf.rep_payments': 'Payments',
  'crf.rep_client_balances': 'Customer balances',
  'crf.rep_no_balance': 'No outstanding balance',
  'crf.rep_payment_history': 'Payment history',
  'crf.rep_no_payment': 'No payment in the period',
  'crf.rep_deleted_client': 'Deleted customer',
  'crf.rep_type_credit': 'Credit',
  'crf.rep_type_payment': 'Payment',
  'crf.rep_type_adjust': 'Adjustment',

  'csf.all_categories': 'All',
  'csf.no_result': 'No result',
  'csf.no_active_product': 'No active product',
  'csf.try_other': 'Try another term',
  'csf.add_active_hint': 'Add products with the "Active" status',
  'csf.out_of_stock': 'Out of stock',
  'csf.remaining': 'left',
  'csf.promo': 'Sale',
  'csf.clear': 'Clear',
  'csf.click_to_add': 'Click a product to add it to the cart',
  'csf.cash_payment': 'Cash payment',
  'csf.card_payment': 'Card payment',
  'csf.amount_to_pay': 'Amount to pay',
  'csf.amount_received': 'Amount received',
  'csf.change_to_give': 'Change to give',
  'csf.insert_card': 'Insert or tap the card',
  'csf.terminal_hint': 'Connected terminal · Contactless accepted',
  'csf.insufficient': 'The amount received is insufficient.',
  'csf.processing': 'Processing...',
  'csf.validate_payment': 'Validate payment',
  'csf.back': 'Back',
  'csf.payment_accepted': 'Payment accepted',
  'csf.order': 'Order',
  'csf.articles': 'Items',
  'csf.payment_method': 'Payment method',
  'csf.cash_label': 'Cash',
  'csf.card_label': 'Bank card',
  'csf.change_label': 'Change given',
  'csf.new_sale': 'New sale',
  'csf.check_access': 'Checking access...',
  'csf.load_error': 'Error loading products',
  'csf.sale_offline_error': 'Could not save the sale offline',
  'csf.sale_error': 'Error during checkout',

  'prf.new_title': 'New product',
  'prf.new_subtitle': 'Add a product to your catalog',
  'prf.edit_title': 'Edit product',
  'prf.created': 'Product created successfully!',
  'prf.updated': 'Product updated successfully!',
  'prf.uploading_media': 'Uploading media...',
  'prf.general_info': 'General information',
  'prf.product_name': 'Product name',
  'prf.product_name_ph': 'E.g. Premium T-shirt',
  'prf.description': 'Description',
  'prf.description_ph': 'Describe your product...',
  'prf.category': 'Category',
  'prf.no_category': 'No category',
  'prf.status': 'Status',
  'prf.status_draft': 'Draft',
  'prf.status_active': 'Active',
  'prf.status_inactive': 'Inactive',
  'prf.price': 'Price',
  'prf.stock': 'Stock',
  'prf.enable_promo': 'Enable promotion',
  'prf.promo_price': 'Promotional price',
  'prf.media': 'Media',
  'prf.cover_image': 'Cover image',
  'prf.click_drag_image': 'Click or drag an image',
  'prf.click_drag_video': 'Click or drag a video',
  'prf.additional_images': 'Additional images',
  'prf.add': 'Add',
  'prf.short_video': 'Short video',
  'prf.variants': 'Variants',
  'prf.has_variants': 'This product has variants (sizes, colors...)',
  'prf.variant_type_ph': 'Type (e.g. Size)',
  'prf.variant_options_ph': 'Options (e.g. S, M, L)',
  'prf.add_variant_type': 'Add a variant type',
  'prf.pricing': 'Pricing:',
  'prf.single_price': 'Single price',
  'prf.per_variant': 'Price per variant',
  'prf.combination': 'Combination',
  'prf.generated_combos': 'Generated combinations',
  'prf.create_product': 'Create product',
  'prf.save': 'Save',
  'prf.saving': 'Saving...',
  'prf.creating': 'Creating...',
  'prf.cancel': 'Cancel',
  'prf.name_required': 'Name is required',
  'prf.invalid_price': 'Invalid price',
  'prf.invalid_stock': 'Invalid stock',
  'prf.invalid_promo': 'Invalid promo price',
  'prf.image_url': 'Image (URL)',
  'prf.view_details': 'View details',
  'prf.edit_btn': 'Edit',
  'prf.uploading': 'Uploading...',
  'home.hero.badge': 'Official launch — Early adopter offer',
  'home.hero.title1': 'Your business online,',
  'home.hero.title2prefix': 'in',
  'home.hero.highlight': 'minutes',
  'home.hero.subtitle': 'ZIFEK combines the power of Shopify, Wix and Fiverr in one AI-powered platform. Create your e-commerce site, showcase or marketplace — no code.',
  'home.hero.cta1': 'Start for free',
  'home.hero.cta2': 'Discover ZIFEK',
  'home.hero.prooflabel': 'entrepreneurs trust us',
  'home.stats.badge': 'Key figures',
  'home.stats.visits': 'Visits generated',
  'home.stats.products': 'Products added',
  'home.stats.services': 'Services offered',
  'home.stats.sites': 'Sites created',
  'home.stats.title': 'The platform in numbers',
  'home.stats.subtitle': 'Real figures, calculated live from the Zifek platform.',
  'home.features.badge': 'All-in-one',
  'home.features.title': 'One platform.\nEvery possibility.',
  'home.features.subtitle': 'ZIFEK replaces 8 different tools. Create, manage and grow your online business from a single place.',
  'home.features.i0.title': 'Full e-commerce',
  'home.features.i0.desc': 'Manage your physical and digital products, variants, stock and shipping. Everything you need to sell online.',
  'home.features.i1.title': 'Service offerings',
  'home.features.i1.desc': 'Offer your services with online booking, calendar, appointments and integrated payment.',
  'home.features.i2.title': 'Native AI',
  'home.features.i2.desc': 'AI automatically generates your site, descriptions and logo. Describe your business and ZIFEK builds everything.',
  'home.features.i3.title': 'Customizable design',
  'home.features.i3.desc': 'Professional themes and a visual editor. Customize every detail without writing a single line of code.',
  'home.features.i4.title': 'Multiple payment gateways',
  'home.features.i4.desc': 'Stripe, PayPal, CMI, PayDunya, Flutterwave. Accept payments from around the world securely.',
  'home.features.i5.title': 'Multi-language & multi-currency',
  'home.features.i5.desc': 'French, English, Arabic, Spanish. Every store can be multilingual with its own currency.',
  'home.how.badge': 'Simple and fast',
  'home.how.title': 'How does it work?',
  'home.how.subtitle': 'Launch your online business in 3 steps. No technical skills, no code.',
  'home.how.hint': 'Most stores are up and running in under 10 minutes',
  'home.how.i0.title': 'Create your store',
  'home.how.i0.desc': 'Describe your activity in a few words. ZIFEK AI generates your complete e-commerce site with your products, design and visual identity.',
  'home.how.i1.title': 'Customize your world',
  'home.how.i1.desc': 'Choose from dozens of professional themes, add your products, set up your payment methods and custom domain.',
  'home.how.i2.title': 'Sell and grow',
  'home.how.i2.desc': 'Launch your store, accept payments, manage orders and track performance. ZIFEK handles the tech, you focus on your business.',
  'home.testi.badge': 'Testimonials',
  'home.testi.title': 'They chose ZIFEK',
  'home.testi.subtitle': 'Entrepreneurs already launched their business with ZIFEK.',
  'home.testi.i0.text': 'ZIFEK turned my Instagram shop into a real e-commerce site in 1 day. My sales tripled the first month. The AI even generated all my product descriptions!',
  'home.testi.i0.role': 'Founder, BeautyByFatima',
  'home.testi.i1.text': 'I was looking for a solution to sell my courses and manage bookings. ZIFEK does both perfectly. The appointment system is stunning.',
  'home.testi.i1.role': 'Coach & Trainer',
  'home.testi.i2.text': 'After testing Shopify, Wix and WordPress, ZIFEK is the only platform that truly combines everything. My clients love the simplicity.',
  'home.testi.i2.role': 'CEO, DigitalSell',
  'home.testi.i3.text': 'I know nothing about computers but I built my site all by myself thanks to ZIFEK. The AI guided me step by step. It is magic!',
  'home.testi.i3.role': 'Artisan, MainsDorees',
  'home.pricing.badge': 'Pricing',
  'home.pricing.title': 'Plans that fit your growth',
  'home.pricing.subtitle': 'Start for free, upgrade when ready. No commitment, no hidden fees.',
  'home.pricing.monthly': 'Monthly',
  'home.pricing.annual': 'Annual',
  'home.pricing.popular': 'Most popular',
  'home.pricing.annual_note': 'billed annually',
  'home.pricing.i0.name': 'Free',
  'home.pricing.i0.desc': 'To get started and test the platform',
  'home.pricing.i0.cta': 'Start for free',
  'home.pricing.i0.f0': 'Up to 10 products',
  'home.pricing.i0.f1': 'Basic themes',
  'home.pricing.i0.f2': 'ZIFEK subdomain',
  'home.pricing.i0.f3': 'Online payment',
  'home.pricing.i0.f4': 'Dashboard',
  'home.pricing.i0.f5': 'Email support',
  'home.pricing.i1.name': 'Partner',
  'home.pricing.i1.desc': 'For small shops and freelancers',
  'home.pricing.i1.cta': 'Choose Partner',
  'home.pricing.i1.f0': 'Up to 100 products',
  'home.pricing.i1.f1': 'Premium themes',
  'home.pricing.i1.f2': 'Custom domain',
  'home.pricing.i1.f3': 'All payment gateways',
  'home.pricing.i1.f4': 'Booking & calendar',
  'home.pricing.i1.f5': 'Built-in blog',
  'home.pricing.i1.f6': 'Priority support',
  'home.pricing.i2.name': 'Business',
  'home.pricing.i2.desc': 'For growing businesses',
  'home.pricing.i2.cta': 'Choose Business',
  'home.pricing.i2.f0': 'Unlimited products',
  'home.pricing.i2.f1': 'All themes + advanced editor',
  'home.pricing.i2.f2': 'Custom domain + emails',
  'home.pricing.i2.f3': 'Advanced AI (logo, SEO, content)',
  'home.pricing.i2.f4': 'Multi-vendor marketplace',
  'home.pricing.i2.f5': 'API & webhooks',
  'home.pricing.i2.f6': 'Advanced analytics',
  'home.pricing.i2.f7': '24/7 dedicated support',
  'home.faq.badge': 'FAQ',
  'home.faq.title': 'Frequently asked questions',
  'home.faq.subtitle': 'Everything you need to know about ZIFEK.',
  'home.faq.i0.q': 'Can I really create a site without knowing how to code?',
  'home.faq.i0.a': 'Absolutely! ZIFEK is designed so anyone, even without technical knowledge, can create a professional site. Our visual editor and AI guide you step by step.',
  'home.faq.i1.q': 'What types of payment can I accept?',
  'home.faq.i1.a': 'ZIFEK supports Stripe, PayPal, CMI (Morocco), PayDunya, Flutterwave and cash on delivery. Enable one or more gateways as needed.',
  'home.faq.i2.q': 'Can I have my own domain name?',
  'home.faq.i2.a': 'Yes! Every store gets a free subdomain (mystore.zifek.fr) and you can also connect your own custom domain.',
  'home.faq.i3.q': 'How does ZIFEK AI work?',
  'home.faq.i3.a': 'Simply describe your activity and AI automatically generates your complete site: pages, colors, logo, services, descriptions and SEO structure.',
  'home.faq.i4.q': 'Is my data secure?',
  'home.faq.i4.a': 'Security is our priority. All data is encrypted, payments go through PCI-DSS gateways, and automatic daily backups are made.',
  'home.faq.i5.q': 'Are there transaction fees on my sales?',
  'home.faq.i5.a': 'ZIFEK charges no transaction fees on your sales. You only pay the standard fees of your payment gateway.',
  'home.faq.i6.q': 'Can I migrate my existing site to ZIFEK?',
  'home.faq.i6.a': 'Yes, we offer assisted migration for Shopify, WooCommerce, Wix and other platforms. Our team supports you.',
  'home.cta.before': 'Ready to launch',
  'home.cta.highlight': 'your business',
  'home.cta.after': 'online?',
  'home.cta.subtitle': 'Create your site for free, with no commitment, and start your activity in minutes.',
  'home.cta.button': 'Create my site for free',
  'home.footer.about': 'The all-in-one SaaS platform to build your online business. E-commerce, services, marketplace, bookings. No code, AI-powered.',
  'home.footer.copyright': 'ZIFEK. All rights reserved.',
  'home.footer.account': 'Account',
  'home.footer.privacy': 'Privacy',
  'home.footer.terms': 'Terms',
  'home.footer.cookies': 'Cookies',
  'home.footer.email_ph': 'Your email',
  'home.footer.subscribe': 'Subscribe',
  'home.footer.subscribed': 'Subscribed!',
} as Record<string, string>;